module.exports = __webpack_public_path__ + "static/image11-d421701c5b0aeaaa5674ae7cd7d2a6bb.png";